import { SearchSliceType } from "../../../types";

export const initSearch:SearchSliceType = {
    search: ""
}